<template>
  <v-container>
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-card>
      <v-container>
        <v-layout>
          <v-flex>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Recepción de Cuadraturas Curso</v-toolbar-title
              >
            </v-toolbar>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md12>
            <v-card max-width="100%" height="115">
              <v-card-text>Nivel: {{ this.idNivel }}</v-card-text>
              <v-card-text>Tipo De Prueba: {{ this.tipoPrueba }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <br />
        <v-layout justify-center>
          <v-flex xs12 md4>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Código curso"
              single-line
              hide-details
              @keyup.enter.stop.prevent="loadData()"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="regionValue"
              @change="comunaFiltro()"
              item-text="nombre"
              item-value="code"
              :items="regionesSelect"
              label="Región"
            ></v-select>
          </v-flex>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="comunaValue"
              item-text="nombre"
              item-value="code"
              :items="comunasSelect"
              label="Comuna"
            ></v-select>
          </v-flex>

          <v-btn
            fab
            dark
            color="teal"
            title="Filtrar detalle"
            @click="loadData()"
          >
            <v-icon dark>filter_list</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="red darken-4"
            title="Limpiar filtros"
            @click="clear()"
          >
            <v-icon dark>clear_all</v-icon>
          </v-btn>
        </v-layout>

        <div id="grid-cuadratura">
          <v-layout justify-center>
            <v-flex lg12>
              <div v-if="loading">
                <loading></loading>
              </div>
              <v-spacer></v-spacer>
              <v-data-table
                :headers="headers"
                :items="itemsCuadraturas"
                :search="search"
                :rows-per-page-items="rowsPerPageItems"
                class="elevation-1"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
                  <td class="text-xs-left">{{ props.item.idNivel }}</td>
                  <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                  <td
                    v-if="props.item.cantLC == props.item.cantLC_REC"
                    class="text-xs-center"
                  >
                    {{ props.item.cantLC }}/{{ props.item.cantLC_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantLC != props.item.cantLC_REC"
                  >
                    {{ props.item.cantLC }}/{{ props.item.cantLC_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantFa == props.item.cantFa_REC"
                  >
                    {{ props.item.cantFa }}/{{ props.item.cantFa_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantFa != props.item.cantFa_REC"
                  >
                    {{ props.item.cantFa }}/{{ props.item.cantFa_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantPCLen == props.item.cantPCLen_REC"
                  >
                    {{ props.item.cantPCLen }}/{{ props.item.cantPCLen_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantPCLen != props.item.cantPCLen_REC"
                  >
                    {{ props.item.cantPCLen }}/{{ props.item.cantPCLen_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantPCMat == props.item.cantPCMat_REC"
                  >
                    {{ props.item.cantPCMat }}/{{ props.item.cantPCMat_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantPCMat != props.item.cantPCMat_REC"
                  >
                    {{ props.item.cantPCMat }}/{{ props.item.cantPCMat_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantPCSoc == props.item.cantPCSoc_REC"
                  >
                    {{ props.item.cantPCSoc }}/{{ props.item.cantPCSoc_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantPCSoc != props.item.cantPCSoc_REC"
                  >
                    {{ props.item.cantPCSoc }}/{{ props.item.cantPCSoc_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantPCNat == props.item.cantPCNat_REC"
                  >
                    {{ props.item.cantPCNat }}/{{ props.item.cantPCNat_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantPCNat != props.item.cantPCNat_REC"
                  >
                    {{ props.item.cantPCNat }}/{{ props.item.cantPCNat_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantPCEsc == props.item.cantPCEsc_REC"
                  >
                    {{ props.item.cantPCEsc }}/{{ props.item.cantPCEsc_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantPCEsc != props.item.cantPCEsc_REC"
                  >
                    {{ props.item.cantPCEsc }}/{{ props.item.cantPCEsc_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantCe == props.item.cantCe_REC"
                  >
                    {{ props.item.cantCe }}/{{ props.item.cantCe_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantCe != props.item.cantCe_REC"
                  >
                    {{ props.item.cantCe }}/{{ props.item.cantCe_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantCp == props.item.cantCp_REC"
                  >
                    {{ props.item.cantCp }}/{{ props.item.cantCp_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantCp != props.item.cantCp_REC"
                  >
                    {{ props.item.cantCp }}/{{ props.item.cantCp_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantCd == props.item.cantCd_REC"
                  >
                    {{ props.item.cantCd }}/{{ props.item.cantCd_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantCd != props.item.cantCd_REC"
                  >
                    {{ props.item.cantCd }}/{{ props.item.cantCd_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantDl == props.item.cantDl_REC"
                  >
                    {{ props.item.cantDl }}/{{ props.item.cantDl_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantDl != props.item.cantDl_REC"
                  >
                    {{ props.item.cantDl }}/{{ props.item.cantDl_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantDm == props.item.cantDm_REC"
                  >
                    {{ props.item.cantDm }}/{{ props.item.cantDm_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantDm != props.item.cantDm_REC"
                  >
                    {{ props.item.cantDm }}/{{ props.item.cantDm_REC }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="props.item.cantDir == props.item.cantDir_REC"
                  >
                    {{ props.item.cantDir }}/{{ props.item.cantDir_REC }}
                  </td>
                  <td
                    class="text-xs-center font-weight-bold red"
                    v-if="props.item.cantDir != props.item.cantDir_REC"
                  >
                    {{ props.item.cantDir }}/{{ props.item.cantDir_REC }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
        <br />

        <!-- dsoto -->
        <div class="text-center pt-2">
          <v-pagination
            @input="changePage(page)"
            v-model="page"
            :length="totalPages"
            :total-visible="9"
            circle
          >
          </v-pagination>
        </div>

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="primary" @click="descarga()"
            >Descarga Cuadraturas</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>

        <v-dialog v-model="dialogLoading" persistent max-width="390">
          <loading-descarga></loading-descarga>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import { misMixins } from "@/mixins/myMixing.js";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";

export default {
  name: "grid-cuadratura",

  components: {
    Loading,
    AlertEmpty,
    LoadingDescarga,
    CargaMasiva,
  },
  mixins: [misMixins],
  props: {},

  data() {
    return {
      search: "",
      page: 1,
      pages: 1,
      rowsPerPageItems: [20],
      totalPages: 0,
      total: "",
      dialogLoading: false,
      loading: false,
      usuarioLoggedTipe: "",
      loading: false,
      idContrato: "",
      headers: [
        { text: "Curso", align: "left", sortable: false, value: "codigoCurso" },
        { text: "ID Nivel", align: "left", sortable: false, value: "nivel" },
        { text: "Tipo Prueba", sortable: false, value: "tipoPrueba" },
        { text: "cantLC", sortable: false, value: "cantLC" },
        { text: "cantFa", sortable: false, value: "cantFa" },
        { text: "cantPCLen", sortable: false, value: "cantPCLen" },
        { text: "cantPCMat", sortable: false, value: "cantPCMat" },
        { text: "cantPCSoc", sortable: false, value: "cantPCSoc" },
        { text: "cantPCNat", sortable: false, value: "cantPCNat" },
        { text: "cantPCEsc", sortable: false, value: "cantPCEsc" },
        { text: "cantCe", sortable: false, value: "cantCe" },
        { text: "cantCp", sortable: false, value: "cantCp" },
        { text: "cantCd", sortable: false, value: "cantCd" },
        { text: "cantDl", sortable: false, value: "cantDl" },
        { text: "cantDm", sortable: false, value: "cantDm" },
        { text: "cantDir", sortable: false, value: "cantDir" },
      ],
      itemsCuadraturas: [],
      nivelSelect: [],
      nivelValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      regionesSelect: [],
      regionValue: null,
      comunasSelect: [],
      comunaValue: null,
      codCursoValue: null,
      codCursoSelect: [],
      proceso: "",
      idNivel: "",
      tipoPrueba: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;

    this.tipoPrueba = this.$route.params.tipoPrueba;
    this.idNivel = this.$route.params.idNivel;

    this.id = this.$route.params.id;
    this.tab = this.$store.getters.subTabSelectedStored;

    this.loadData();
    this.loadDataComuna();
    this.loadDataCodigo();
  },

  mounted() {},
  methods: {
    async loadCuadraturas() {
      this.body = {
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        comuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,

        codCurso: this.search,
        idContrato: this.idContrato,
        proceso: this.proceso,
        pageSize: 20,
        pageNumber: this.page,
        idNivel: this.idNivel,
        tipoPrueba: this.tipoPrueba,
      };
      return await axios
        .post("/cuadraturas/getAllByFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
          return [];
        });
    },
    async loadData() {
      this.loading = true;
      var response = await this.loadCuadraturas();
      this.itemsCuadra = response;
      this.itemsCuadraturas = response.cuadraturas;

      if (this.itemsCuadraturas.length > 0) {
        this.pages = response.total;
        this.totalPages = Math.ceil(this.pages / 20);
        this.alerta = false;
      } else {
        this.alerta = true;
        this.page = 1;
        this.totalPages = 0;
        this.pages = 1;
      }
      this.loading = false;
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData();
    },
    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
    descarga() {
      this.dialogLoading = true;
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Descarga_Cuadraturas_Curso.xlsx";
      let proceso = this.$store.getters.proSelectedStored;

      this.body = {
        idContrato: idContrato,
        proceso: proceso,
        idNivel: this.idNivel,
        tipoPrueba: this.tipoPrueba,
      };
      axios
        .post("/cuadraturas/descargaCursoAnt", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataCodigo() {
      this.itemsCodigoCurso = await this.loadCodigoCurso();
      if (this.itemsCodigoCurso.length > 0) {
        this.codCursoSelect = this.itemsCodigoCurso;
      }
    },
    async loadCodigoCurso() {
      return await axios
        .get("/cuadraturas/codigoCurso/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    clear() {
      this.regionValue = "";
      this.comunaValue = "";
      this.codCursoValue = "";
      this.loadData();
    },
    volver() {
      this.$router.back();
    },
  },
};
</script>
